import { render } from "./PorosityFilter.vue?vue&type=template&id=0a766018"
import script from "./PorosityFilter.vue?vue&type=script&lang=js"
export * from "./PorosityFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__